module.exports = __webpack_public_path__ + "img/location-pin.2c5a3b09.svg";